import { Alert } from '@pocketlaw/tetris';
import { Container } from './styled';
export function Error(props) {
    const { title, message } = props;
    return (<Container>
      <Alert appearance="danger" title={title} message={message}/>
    </Container>);
}
